import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Achievement, Cog, InactiveHome, SearchIc } from "../svg/GeneralIcons";
import clsx from "clsx";

function Nav({
  activeClass,
  activeColor,
  inactiveClass,
  navBg,
  firstIcon,
  secondIcon,
  thirdIcon,
  fourthIcon,
  firstText,
  secondText,
  thirdText,
  fourthText,
  firstLink,
  secondLink,
  thirdLink,
  fourthLink,
}) {
  const navigate = useNavigate();
  const [active, setActive] = useState("home");
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.includes("search") ||
      location.pathname.includes("live")
    ) {
      setActive("search");
    } else if (
      location.pathname.includes("settings") ||
      location.pathname.includes("profile")
    ) {
      setActive("settings");
    } else if (location.pathname.includes("achievements")) {
      setActive("achievements");
    } else {
      setActive("home");
    }
  }, []);

  return (
    <div
      className={clsx(
        navBg,
        "fixed 480:sticky bottom-0 480:bottom-0 z-[3000] w-full bg-[#FFFFFF]"
      )}
    >
      <div className="container flex justify-between px-[8%] py-2.5">
        <div
          onClick={() => {
            navigate(firstLink ? `/worlds/${firstLink}` : "/home");
          }}
          className={clsx(
            active === "home" ? activeClass : inactiveClass,
            "grid cursor-pointer justify-items-center"
          )}
          style={active === "home" && activeColor ? { color: activeColor } : undefined}
        >
          {firstIcon ?? (
            <InactiveHome
              className={clsx(
                "w-5 h-5",
                active === "home" ? "text-primary-main" : ""
              )}
            />
          )}
          <p
            className="text-[10px] font-semibold"
            style={active === "home" && activeColor ? { color: activeColor } : undefined}
          >
            {firstText ?? "Home"}
          </p>
        </div>
        <div
          onClick={() => {
            navigate(secondLink ? `/worlds/${secondLink}` : "/search");
          }}
          className={clsx(
            active === "search" ? activeClass : inactiveClass,
            "grid cursor-pointer justify-items-center"
          )}
          style={active === "search" && activeColor ? { color: activeColor } : undefined}
        >
          {secondIcon ?? (
            <SearchIc
              className={clsx(
                "w-5 h-5",
                active === "search" ? "text-primary-main" : ""
              )}
            />
          )}
          <p
            className="text-[10px] font-semibold"
            style={active === "search" && activeColor ? { color: activeColor } : undefined}
          >
            {secondText ?? "Search"}
          </p>
        </div>
        <div
          onClick={() => {
            navigate(thirdLink ? `/worlds/${thirdLink}` : "/achievements");
          }}
          className={clsx(
            active === "achievements" ? activeClass : inactiveClass,
            "grid cursor-pointer justify-items-center"
          )}
          style={active === "achievements" && activeColor ? { color: activeColor } : undefined}
        >
          {thirdIcon ?? (
            <Achievement
              className={clsx(
                "w-5 h-5",
                active === "achievements" ? "text-primary-main" : ""
              )}
            />
          )}
          <p
            className="text-[10px] font-semibold"
            style={active === "achievements" && activeColor ? { color: activeColor } : undefined}
          >
            {thirdText ?? "Achievements"}
          </p>
        </div>
        <div
          onClick={() => {
            navigate(fourthLink ? `/worlds/${fourthLink}` : "/settings");
          }}
          className={clsx(
            active === "settings" ? activeClass : inactiveClass,
            "grid cursor-pointer justify-items-center"
          )}
          style={active === "settings" && activeColor ? { color: activeColor } : undefined}
        >
          {fourthIcon ?? (
            <Cog
              className={clsx(
                "w-5 h-5",
                active === "settings" ? "text-primary-main" : ""
              )}
            />
          )}
          <p
            className="text-[10px] font-semibold"
            style={active === "settings" && activeColor ? { color: activeColor } : undefined}
          >
            {fourthText ?? "Settings"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Nav;
